import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./AccountSettings'));

function LoadableAccountSettings() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableAccountSettings;

